module.exports = __webpack_public_path__ + "static/img/huodong.8673b6de.png";